import * as React from "react";
import PropTypes from 'prop-types';

const SvgYdtFilter = props => {
  if (props.id !== "_svgydtfilter") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M11.23 8.045a2.392 2.392 0 102.383 2.382 2.382 2.382 0 00-2.382-2.382m0-2.045a4.427 4.427 0 014.314 3.404h11.359c.564 0 1.022.458 1.022 1.023.005.513-.371.95-.88 1.022h-11.5a4.437 4.437 0 01-8.629.001h-1.82a1.023 1.023 0 01-1.022-1.023c-.005-.513.371-.95.88-1.023h1.962A4.425 4.425 0 0111.231 6m9.538 12.953a2.384 2.384 0 00.014 4.765 2.383 2.383 0 10-.013-4.765m0-2.044a4.426 4.426 0 014.314 3.404h1.82a1.025 1.025 0 01.143 2.045h-1.963a4.426 4.426 0 01-8.619 0H5.096a1.025 1.025 0 01-.143-2.045h11.512a4.415 4.415 0 014.304-3.404" /></svg>;
};

SvgYdtFilter.displayName = "_svgydtfilter";
SvgYdtFilter.propTypes = {
  id: PropTypes.string
};
SvgYdtFilter.defaultProps = {
  id: ''
};
export default SvgYdtFilter;